export const COOKIE_KEYS = {
    COOKIE_SHIPPING_TERMS_ACCEPTED: "ShippingTermsAccepted",
    COOKIE_SHIPPING_TERMS_POPUP_SHOWN: "ShippingTermsPopupShown"
}